import { AppState } from '../../app/state/AppState';

export function selectPersonalSpace(state: AppState) {
  return state.personalSpace;
}
